export const emailPlaceholder = { de: 'Email', en: 'Email', sv: 'Email' };
export const passwordPlaceholder = { de: 'Password', en: 'Password', sv: 'Lösenord' };
export const twoFaPlaceholder = {
  en: 'Enter two factor authentication code',
  de: 'Enter two factor authentication code',
  sv: 'Ange tvåfaktorsautentiserings kod',
};
export const header = { de: 'Log in', en: 'Log in', sv: 'Logga in' };
export const signupLabel = {
  de: "Don't have an account yet?",
  en: "Don't have an account yet?",
  sv: 'Har du inget konto än?',
};
export const resetPassword = {
  de: 'Forgot your password?',
  en: 'Forgot your password?',
  sv: 'Har du glömt ditt lösenord?',
};
export const loadingLabel = { de: 'Logging in...', en: 'Logging in...', sv: 'Loggar in...' };
